import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

var iniAsiakas;

class ProjektiEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.riviAvain === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            RiviAvain: data[0].riviAvain,
            AsiakasAvain: data[0].asiakasAvain,
            Nimi: data[0].nimi,
            Omistaja: data[0].omistaja,
            Tarkoitus: data[0].tarkoitus,
            Tavoitteet: data[0].tavoitteet,
            Tyyppi: data[0].tyyppi,
            Sijainti: data[0].sijainti,
            OlosuhteetEnnen: data[0].olosuhteetEnnen,
            ParannustenSaavuttaminen: data[0].parannustenSaavuttaminen,
            ArviotuParannustenMaara: data[0].arviotuParannustenMaara,
            Riskit: data[0].riskit,
            RoolitJaVastuut: data[0].roolitJaVastuut,
            Ohjelmat: data[0].ohjelmat,
            Vaikutusarvio: data[0].vaikutusarvio,
            Lopputulemat: data[0].lopputulemat,
            Alkupvm: data[0].alkupvm,
            Loppupvm: data[0].loppupvm,
            Created: data[0].created,
            Updated: data[0].updated,
            Username: data[0].username,
            asiakkaat: (Object.keys(props.lookupLists.asiakkaat).map((d) => ({ value: d, label: props.lookupLists.asiakkaat[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniAsiakas = this.state.asiakkaat.find(({ value }) => value === (this.state.AsiakasAvain || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: this.state.data[0].riviAvain,
            AsiakasAvain: this.state.data[0].asiakasAvain,
            Nimi: this.state.data[0].nimi,
            Omistaja: this.state.data[0].omistaja,
            Tarkoitus: this.state.data[0].tarkoitus,
            Tavoitteet: this.state.data[0].tavoitteet,
            Tyyppi: this.state.data[0].tyyppi,
            Sijainti: this.state.data[0].sijainti,
            OlosuhteetEnnen: this.state.data[0].olosuhteetEnnen,
            ParannustenSaavuttaminen: this.state.data[0].parannustenSaavuttaminen,
            ArviotuParannustenMaara: this.state.data[0].arviotuParannustenMaara,
            Riskit: this.state.data[0].riskit,
            RoolitJaVastuut: this.state.data[0].roolitJaVastuut,
            Ohjelmat: this.state.data[0].ohjelmat,
            Vaikutusarvio: this.state.data[0].vaikutusarvio,
            Lopputulemat: this.state.data[0].lopputulemat,
            Alkupvm: this.state.data[0].alkupvm,
            Loppupvm: this.state.data[0].loppupvm,
            Created: this.state.data[0].created,
            Updated: this.state.data[0].updated,
            Username: this.state.data[0].username
        })
    }

    handleSave = () => {
        this.props.onEditRow({
            RiviAvain: this.state.RiviAvain,
            AsiakasAvain: this.state.AsiakasAvain,
            Nimi: this.state.Nimi,
            Omistaja: this.state.Omistaja,
            Tarkoitus: this.state.Tarkoitus,
            Tavoitteet: this.state.Tavoitteet,
            Tyyppi: this.state.Tyyppi,
            Sijainti: this.state.Sijainti,
            OlosuhteetEnnen: this.state.OlosuhteetEnnen,
            ParannustenSaavuttaminen: this.state.ParannustenSaavuttaminen,
            ArviotuParannustenMaara: this.state.ArviotuParannustenMaara,
            Riskit: this.state.Riskit,
            RoolitJaVastuut: this.state.RoolitJaVastuut,
            Ohjelmat: this.state.Ohjelmat,
            Vaikutusarvio: this.state.Vaikutusarvio,
            Lopputulemat: this.state.Lopputulemat,
            Alkupvm: this.state.Alkupvm,
            Loppupvm: this.state.Loppupvm,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    render() {
        const { dictionary } = this.context;
        const { open, asiakkaat, projektit, osoitteet, toimialat } = this.state;

        const handleChange = name => event => {
            this.setState({
                [name]: event.target.value,
                jotainMuuttui: true
            });
        };

        var handleClickOpen = () => {
            this.setState({
                open: true,
            });
        }

        const handleListChange = (event, newValue, item) => {
            if (newValue != null) {
                this.setState({ [item]: newValue.value })
            }
            else {
                this.setState({ [item]: null })
            }
            this.setState({ jotainMuuttui: true })
        }

        var handleClose = () => {
            if (this.state.jotainMuuttui) {
                this.setState({
                    setOpen: true
                });
            }
            else {
                this.setState({
                    open: false,
                    setOpen: false
                });
            }
        }

        var handleSetOpenCancel = () => {
            this.setState({
                open: true,
                setOpen: false
            });
        }

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={handleClose} maxWidth={false} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">{dictionary.Inventory.Projekti.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <div style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniAsiakas}
                                onChange={(event, newValue) => { handleListChange(event, newValue, 'AsiakasAvain') }}
                                options={asiakkaat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required variant="standard" label={dictionary.Inventory.Projekti.Columns[1]} />}
                            />
                        </div>
                        <TextField
                            required
                            margin="dense"
                            id="Nimi"
                            label={dictionary.Inventory.Projekti.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Nimi}
                            onChange={handleChange('Nimi')}
                        />
                        <TextField
                            required
                            margin="dense"
                            id="Omistaja"
                            label={dictionary.Inventory.Projekti.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Omistaja}
                            onChange={handleChange('Omistaja')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Tarkoitus"
                            label={dictionary.Inventory.Projekti.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Tarkoitus}
                            onChange={handleChange('Tarkoitus')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Tavoitteet"
                            label={dictionary.Inventory.Projekti.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.Tavoitteet}
                            onChange={handleChange('Tavoitteet')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Tyyppi"
                            label={dictionary.Inventory.Projekti.Columns[6]}
                            type="text"
                            fullWidth
                            value={this.state.Tyyppi}
                            onChange={handleChange('Tyyppi')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Sijainti"
                            label={dictionary.Inventory.Projekti.Columns[7]}
                            type="text"
                            fullWidth
                            value={this.state.Sijainti}
                            onChange={handleChange('Sijainti')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="OlosuhteetEnnen"
                            label={dictionary.Inventory.Projekti.Columns[8]}
                            type="text"
                            fullWidth
                            value={this.state.OlosuhteetEnnen}
                            onChange={handleChange('OlosuhteetEnnen')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="ParannustenSaavuttaminen"
                            label={dictionary.Inventory.Projekti.Columns[9]}
                            type="text"
                            fullWidth
                            value={this.state.ParannustenSaavuttaminen}
                            onChange={handleChange('ParannustenSaavuttaminen')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="ArviotuParannustenMaara"
                            label={dictionary.Inventory.Projekti.Columns[10]}
                            type="text"
                            fullWidth
                            value={this.state.ArviotuParannustenMaara}
                            onChange={handleChange('ArviotuParannustenMaara')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Riskit"
                            label={dictionary.Inventory.Projekti.Columns[11]}
                            type="text"
                            fullWidth
                            value={this.state.Riskit}
                            onChange={handleChange('Riskit')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="RoolitJaVastuut"
                            label={dictionary.Inventory.Projekti.Columns[12]}
                            type="text"
                            fullWidth
                            value={this.state.RoolitJaVastuut}
                            onChange={handleChange('RoolitJaVastuut')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Ohjelmat"
                            label={dictionary.Inventory.Projekti.Columns[13]}
                            type="text"
                            fullWidth
                            value={this.state.Ohjelmat}
                            onChange={handleChange('Ohjelmat')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Vaikutusarvio"
                            label={dictionary.Inventory.Projekti.Columns[14]}
                            type="text"
                            fullWidth
                            value={this.state.Vaikutusarvio}
                            onChange={handleChange('Vaikutusarvio')}
                        />
                        <TextField
                            multiline
                            margin="dense"
                            id="Lopputulemat"
                            label={dictionary.Inventory.Projekti.Columns[15]}
                            type="text"
                            fullWidth
                            value={this.state.Lopputulemat}
                            onChange={handleChange('Lopputulemat')}
                        />
                        <TextField
                            required
                            margin="dense"
                            id="Alkupvm"
                            label={dictionary.Inventory.Projekti.Columns[16]}
                            type="text"
                            fullWidth
                            value={this.state.Alkupvm}
                            onChange={handleChange('Alkupvm')}
                        />
                        <TextField
                            required
                            margin="dense"
                            id="Loppupvm"
                            label={dictionary.Inventory.Projekti.Columns[17]}
                            type="text"
                            fullWidth
                            value={this.state.Loppupvm}
                            onChange={handleChange('Loppupvm')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ProjektiEdit" })(ProjektiEdit);
